import { useDroppable } from '@dnd-kit/core'
import { Box } from '@mui/material'
import type { ReactNode } from 'react'

interface DroppableContainerProps {
  id: string
  /** Stretch to fill the remaining space of its parent, so the whole column accepts drops. */
  fill?: boolean
  /** Shown when the container holds no sections (an empty chapter is still a drop target). */
  emptyHint?: string
  isEmpty?: boolean
  children: ReactNode
}

export default function DroppableContainer({ id, fill, emptyHint, isEmpty, children }: DroppableContainerProps) {
  const { setNodeRef, isOver } = useDroppable({ id })

  return (
    <Box
      ref={setNodeRef}
      sx={{
        minHeight: 32,
        ...(fill ? { flex: 1 } : {}),
        borderRadius: 1,
        transition: 'background-color 0.15s ease',
        bgcolor: isOver ? 'rgba(144, 202, 249, 0.08)' : 'transparent',
        ...(isEmpty
          ? {
              border: '1px dashed',
              borderColor: isOver ? 'primary.main' : 'divider',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              px: 1,
              py: 1.5,
              fontSize: '0.75rem',
              fontStyle: 'italic',
              color: 'text.disabled',
            }
          : {}),
      }}
    >
      {isEmpty && emptyHint ? emptyHint : children}
    </Box>
  )
}
